
import type { PropType } from 'vue'
import type { RoleAssignmentConditionMessages } from '../../models'
import { computed, defineComponent, getCurrentInstance, nextTick, ref, watch } from 'vue'
import { ColorEnum } from '../../enums'
import EditableLabel from '../editable-label.component.vue'
import { UiCheckbox } from '../keen-ui'
import { EpbPill } from '../shared/epb-pill'
import { EpbText } from '../shared/epb-text'

export interface RoleAssignmentAnyConditionOption {
  value: string
  label?: string
}

export default defineComponent({
  name: 'RoleAssignmentAnyCondition',
  components: {
    EditableLabel,
    EpbPill,
    EpbText,
    UiCheckbox,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array as PropType<Array<RoleAssignmentAnyConditionOption>>,
      default: undefined,
    },
    allowSelectAll: {
      type: Boolean,
      default: false,
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Object as PropType<RoleAssignmentConditionMessages>,
      default: () => ({}),
    },
  },
  emits: {
    input: (value: string) => {},
  },
  setup(props) {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const ALL_VALUE = '*'

    const baseClass = 'epb-role-assignment-any-condition'

    const editable = ref(false)

    const allSelected = computed(() => props.value === ALL_VALUE)

    watch(editable, value => {
      if (value) {
        nextTick(() => {
          ;(ctx.proxy.$refs.editableLabel as any).focus()
        })
      }
    })

    return {
      ALL_VALUE,
      baseClass,
      editable,
      allSelected,
      ColorEnum,
    }
  },
})
